import { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import './AppVersionUpdateDialog.scss';

const AppVersionUpdateDialog = ({ visible, onReload }) => {
    const { t } = useTranslation();
    const [countdown, setCountdown] = useState(500);
    const [isReloading, setIsReloading] = useState(false);

    useEffect(() => {
        if (visible) {
            setCountdown(500);
            const interval = setInterval(() => {
                setCountdown(prev => {
                    if (prev <= 1) {
                        clearInterval(interval);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [visible]);

    useEffect(() => {
        if (visible && countdown === 0 && onReload) {
            // Automatyczny reload po zakończeniu odliczania
            onReload();
        }
    }, [visible, countdown, onReload]);

    const handleReload = () => {
        if (onReload) {
            onReload();
        }
    };

    return (
       <Dialog
            header={t('appVersionUpdate.title')}
            visible={visible}
            position="center"
            onHide={() => {}}
            className="app-version-update-dialog"
            closable={false}
            modal
            draggable={false}
            resizable={false}
            focusOnShow={false}
            closeOnEscape={false}
            appendTo={document.body}
        >
            <div className="app-version-update-dialog-content">
                <div className="app-version-update-message">
                    <div className="app-version-update-message-1">  
                        {t('appVersionUpdate.message1')}
                    </div>
                    <div className="app-version-update-message-2">
                        {t('appVersionUpdate.message2', { countdown })}
                    </div>
                </div>
                <div className="app-version-update-buttons">
                    <Button
                        label={t('appVersionUpdate.reloadNow')}
                        onClick={() => {
                            setIsReloading(true);
                            handleReload();
                        }}
                        className="app-version-update-reload-button"
                        loading={isReloading}
                    />
                </div>
            </div>
        </Dialog>
    );
};

export default AppVersionUpdateDialog;

